import { AuthenticatedLayout } from '@/components/Common/Layout/Authenticated/AuthenticatedLayout';
import { useIntl } from 'react-intl';

export default function Home() {
  const i18n = useIntl();
  return (
    <AuthenticatedLayout pageTitleId='Home_Page_Title' i18n={i18n}>
      <div>
        <h1>Home</h1>
      </div>
    </AuthenticatedLayout>
  );
}
